/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import { defineMessages } from 'react-intl';

//
// Default messages are 'en-US'
//

const messages = defineMessages({
  closeButtonText: {
    id: 'closeButtonText',
    description: 'this is close button text',
    defaultMessage: 'Close'
  },
  thumbNailAlt: {
    id: 'thumbNailAlt',
    description: 'this is alt text for default thumbnail image',
    defaultMessage: 'Preview Image'
  },
  next: {
    id: 'next',
    defaultMessage: 'Next Page'
  },
  previous: {
    id: 'previous',
    defaultMessage: 'Previous Page'
  },
  addNote: {
    id: 'addNote',
    defaultMessage: 'Add a note...'
  }
});

export default messages;



// WEBPACK FOOTER //
// ./src/js/defaultMessages.jsx